import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static values = {
    elementId: String,
    classes: { type: String, default: 'hidden' },
    applyOnStart: { type: Boolean, default: true },
    appliedContent: { type: String, default: '▽' },
    notAppliedContent: { type: String, default: '△' },
  };

  connect() {
    if (this.applyOnStartValue) {
      this.add();
      return;
    }

    this.updateControllerContent();
  }

  toggle() {
    this.withElementAndClasses((element, className) => {
      element.classList.toggle(className);
    });
    this.updateControllerContent();
  }

  add() {
    this.withElementAndClasses((element, className) => {
      element.classList.add(className);
    });
    this.updateControllerContent();
  }

  remove() {
    this.withElementAndClasses((element, className) => {
      element.classList.remove(className);
    });
    this.updateControllerContent();
  }

  withElementAndClasses(callback) {
    const element = this.targetElement();
    const classes = this.configuredClasses();
    if (!element || classes.length === 0) return;

    classes.forEach((className) => callback(element, className));
  }

  targetElement() {
    if (!this.hasElementIdValue) return null;

    const normalizedId = String(this.elementIdValue).replace(/^#/, '');
    return document.getElementById(normalizedId);
  }

  configuredClasses() {
    return String(this.classesValue || '')
      .split(/\s+/)
      .filter(Boolean);
  }

  classesApplied() {
    const element = this.targetElement();
    if (!element) return false;

    const classes = this.configuredClasses();
    if (classes.length === 0) return false;

    return classes.every((className) => element.classList.contains(className));
  }

  updateControllerContent() {
    this.element.textContent = this.classesApplied()
      ? this.appliedContentValue
      : this.notAppliedContentValue;
  }
}
